import { BankAccount } from "./bank-account";
import { OrderLine } from "./order-line";
import { Party } from "./party";
import { VatGroup } from "./vat-group";

export interface AllowanceCharge {
	ChargeIndicator: boolean;
	AllowanceChargeReason: string;
	AllowanceChargeReasonCode: string;
	Amount: number;
	TaxCategoryID: string;
	TaxPercent: number;
}

export interface AdditionalDocumentReference {
	ID: string;
	DocumentDescription: string;
}

export interface IAttachment {
	FileName:string;
	MimeType:string;
	FileContent:string;
}

export class Order {
	Customer:Party;
	Supplier:Party;
	OrderNumber:string;
	OrderDate:Date;
	ExpiryDate:Date;
	OrderType:string;
	OrderLines:OrderLine[];
	Journal:string;
	OrderTitle:string;
	PaymentReference:string;
	PaymentDiscountPercentage:number;
	PaymentDiscountAmount:number;
	VatGroups:VatGroup[];
	VentilationCode:string;
	TotalExcl:number = 0.0;
	TotalIncl:number = 0.0;
	TotalVAT:number = 0.0;
	Reference:string;
	Tags:string[];
	Comments:string;
	Currency:string;
	SettlementDiscountPercent:number;
	SettlementDiscountAmount:number;
	SettlementDiscountEndDate:Date;
	//OrderPdf:Attachment;
	//Attachments:Attachment[];
	BankAccount:BankAccount | null = null;
	SenderEndpointID:string;
	ReceiverEndpointID:string;
	SBDID:string;

	// Additional fields from XML parsing
	PaymentTermsNote: string;
	AllowanceCharges: AllowanceCharge[];
	AdditionalDocumentReferences: AdditionalDocumentReference[];
	// Cash discount (korting contant) fields
	CashDiscountPercent: number;
	CashDiscountAmount: number;
	CashDiscountDays: number;
	NetDueDays: number;

	OriginalOrder:any;

	// eslint-disable-next-line max-lines-per-function
	public constructor(data:any){
		this.Customer = new Party(data.Customer || {});
		this.Supplier = new Party(data.Supplier || {});
		this.OrderNumber = data.OrderNumber || "";
		this.OrderDate = data.OrderDate ? new Date(data.OrderDate) : new Date();
		this.ExpiryDate = data.ExpiryDate ? new Date(data.ExpiryDate) : new Date();
		this.OrderType = data.OrderType || "";
		this.OrderLines = ((data.OrderLines || []) as any[]).map(o=>new OrderLine(o));
		this.Journal = data.Journal || "";
		this.OrderTitle = data.OrderTitle || "";
		this.PaymentReference = data.PaymentReference || "";
		this.PaymentDiscountPercentage = data.PaymentDiscountPercentage || 0.0;
		this.PaymentDiscountAmount = data.PaymentDiscountAmount || 0.0;
		this.VatGroups = ((data.VatGroups || []) as any[]).map(v=>new VatGroup(v));
		for (let group of this.VatGroups) {
			this.TotalIncl += group.TotalIncl;
			this.TotalVAT += group.TotalVAT;
			this.TotalExcl += group.TotalExcl;
		}
		this.VentilationCode = data.VentilationCode || "";
		this.Reference = data.Reference || "";
		this.Tags = data.Tags || [];
		this.Comments = data.Comments || "";
		this.Currency = data.Currency || "";
		this.SettlementDiscountPercent = data.SettlementDiscountPercent || 0;
		this.SettlementDiscountAmount = data.SettlementDiscountAmount || 0;
		this.SettlementDiscountEndDate = data.SettlementDiscountEndDate ? new Date(data.SettlementDiscountEndDate) : new Date();
		if (data.BankAccount) {
			this.BankAccount = new BankAccount(data.BankAccount);
		}
		this.SenderEndpointID = data.SenderEndpointID || "";
		this.ReceiverEndpointID = data.ReceiverEndpointID || "";
		this.SBDID = data.SBDID || "";

		// Additional fields from XML
		this.PaymentTermsNote = data.PaymentTermsNote || "";
		this.AllowanceCharges = data.AllowanceCharges || [];
		this.AdditionalDocumentReferences = data.AdditionalDocumentReferences || [];
		// Cash discount (korting contant)
		this.CashDiscountPercent = data.CashDiscountPercent || 0;
		this.CashDiscountAmount = data.CashDiscountAmount || 0;
		this.CashDiscountDays = data.CashDiscountDays || 0;
		this.NetDueDays = data.NetDueDays || 0;

		this.OriginalOrder = data;
	}

	public isSelfBilling():boolean {
		return this.OrderType.indexOf("SelfBilled") != -1;
	}
}